export default __webpack_public_path__ + "static/media/ic-instruction-08.1a8a91af.svg";